import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Grid, Icon} from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {dateFormatFullMonth} from '../../../../common/constants/datesFormat';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {pageSizes} from '../../../../common/constants/lists';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import ManualsOrderDetailTable from './table';
import './detail.scss';

class ManualsOrderDetailManager extends Component {
  constructor(props) {
    super(props);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onItemsSelectedSave = this.onItemsSelectedSave.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PickingManualsOrders, scopes.Edit)) {
      this.props.push(paths.AccessDenied);
    }
    const {dealerId, agencyId, orderNumber} = this.props;
    this.props.clearData('ALL');
    this.props.changeOrdersListPageSize(pageSizes[0].value);
    this.props.fetchOrderDetail(dealerId, agencyId, orderNumber);
    this.props.fetchSystemParameter('PICKING_LABELS_TO_CUT');
  }

  onCancelClick() {
    this.props.goBack();
  }

  onItemsSelectedSave() {
    const {allItems, dealerId, agencyId, orderNumber} = this.props;
    const itemsSelected = _.filter(allItems, {'status': 'P', 'checked': true});
    const ordersSequencesList = _.map(itemsSelected, 'orderSequence');

    this.props.saveItemsSelected({dealerId, agencyId, orderNumber}, ordersSequencesList);
  }

  render() {
    const {orderNumber, loading, orderDetail, allItems, saving} = this.props;
    const dateFormatted = orderDetail.date ? moment(orderDetail.date).format(dateFormatFullMonth) : '';
    const itemsSelected = _.filter(allItems, {'status': 'P', 'checked': true});

    return (
      <div className='specials-order-detail'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick}/>
              <h2>Pedido:<span>{orderNumber}</span></h2>
              <div className='title-bar-actions'>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={
                    loading || saving || !itemsSelected.length
                  }
                  onClick={this.onItemsSelectedSave}
                >
                  Imprimir
                </Button>
              </div>
            </div>

            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={3}>
                    <h4>Concesionario:</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    {orderDetail.dealerName}
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Agencia:</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    {orderDetail.agencyName}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3}>
                    <h4>Fecha de Pedido:</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    {dateFormatted}
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Tipo:</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    {orderDetail.orderLocation} {orderDetail.orderType}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            
          </div>
        </Card>
        
        <ManualsOrderDetailTable orderNumber={orderNumber} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {dealerId} = ownProps.params;
  const {agencyId} = ownProps.params;
  const {order} = ownProps.params;

  return {
    dealerId,
    agencyId,
    'orderNumber': order,
    'loading': state.manualsOrders.loadingOrderDetail,
    'orderDetail': state.manualsOrders.orderDetail,
    'allItems': state.manualsOrders.orderDetailItems,
    'saving': state.manualsOrders.saving,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {
  clearData,
  changeOrdersListPageSize,
  fetchOrderDetail,
  fetchSystemParameter,
  saveItemsSelected,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  clearData,
  changeOrdersListPageSize,
  fetchOrderDetail,
  fetchSystemParameter,
  saveItemsSelected,
})(ManualsOrderDetailManager));
